import React from 'react'
import BackButton from '../components/BackButton'
import { FaCheckCircle } from 'react-icons/fa'

const TermsAndConditions = () => {
  return (
    <div className='min-h-[calc(100vh-70px)] p-8 flex flex-col items-center bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100'>
      {/* Back Button */}
      <div className='w-full max-w-4xl mb-4'>
        <BackButton />
      </div>
      <h2 className='text-4xl font-bold mb-8 text-center'>Terms And Conditions</h2>
      <div className='mt-0 w-[200px] h-1 bg-cyan-500 mx-auto rounded'></div>
      
      <div className='max-w-4xl space-y-6 mt-12'>
        {/* Main Terms */}
        <div className='bg-blue-50 dark:bg-blue-900/20 border-2 border-blue-300 dark:border-blue-700 rounded-lg p-8'>
          <h3 className='text-l font-semibold mb-4'>RTO-BHARAT provides application assistance and documentation support services only</h3>
          <ul className='space-y-3 text-gray-700 dark:text-gray-300'>
            <li>• We are not a government body and do not guarantee approval or processing time</li>
            <li>• Final decisions rest solely with the respective government authorities</li>
            <li>• Users are responsible for providing accurate information and documents</li>
            <li>• Service charges are applicable for assistance provided, irrespective of application outcome</li>
          </ul>
        </div>
      </div>
    </div>
  )
}

export default TermsAndConditions
